import { TrackingLineWidth, TrackingLineColor, PluginAccuracy } from './../../providers/tracking.service';
import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TrackingService } from '../../providers/tracking.service';
import { TranslateService } from '@ngx-translate/core';
import { DateFormatModel, LanguageModel, SettingsProvider } from '../../providers/settings/settings';

@Component({
    selector: 'tracking-settings',
    templateUrl: 'tracking-settings.html',
    styleUrls:['./tracking-settings.scss']
})
export class TrackingSettingsPage {
    markerChanged: boolean = false;
    formats: DateFormatModel[] = [];
    selectedDateFormat: string;
    selectedLanguage: string;
    reload: boolean = true;
    unitOptions = [];
    lineWidthOptions = [];
    accuracyOptions = [];
    colorOptions = [];
    languageOptions = [];

    constructor(
        private viewCtrl: ModalController,
        public trackingService: TrackingService,
        private translate: TranslateService,
        private settingsService: SettingsProvider,
        private ref: ChangeDetectorRef
    ) { }


    ngOnInit() {
        this.settingsService.getDateFormats().then(formats => {
            this.formats = formats;
        });
        this.init();
    }

    init(checkSavedFormat = false) {
        this.settingsService.getActiveLanguage().then((lang) => {
            this.selectedLanguage = lang;
            this.settingsService.getActiveDateFormat().then((format: DateFormatModel) => {
                if (format && !checkSavedFormat) {
                    this.selectedDateFormat = format.key;
                } 
                // else {
                //     if (lang.includes("de")) {
                //         this.selectedDateFormat = "dd.MM.yyyy";
                //     } else {
                //         this.selectedDateFormat = "MM/dd/yyyy";
                //     }
                // }
            });
            this.unitOptions = [
                {
                    key: 0,
                    name: this.translate.instant('DISTANCE_UNIT_KM')
                },
                {
                    key: 1,
                    name: this.translate.instant('DISTANCE_UNIT_MILES')
                }
            ];
            this.lineWidthOptions = [
                {
                    key: this.trackingLineWidthValue.TRACKING_LINE_SLIM,
                    name: this.translate.instant('TRACKING_LINE_SLIM')
                },
                {
                    key: this.trackingLineWidthValue.TRACKING_LINE_NORMAL,
                    name: this.translate.instant('TRACKING_LINE_NORMAL')
                },
                {
                    key: this.trackingLineWidthValue.TRACKING_LINE_BROAD,
                    name: this.translate.instant('TRACKING_LINE_BROAD')
                }
            ];
            this.accuracyOptions = [
                {
                    key: this.pluginAccuracy.HIGH,
                    name: this.translate.instant('HIGH')
                },
                {
                    key: this.pluginAccuracy.MEDIUM,
                    name: this.translate.instant('MEDIUM')
                }
            ];
            this.colorOptions = [
                {
                    key: this.trackingLineColorValue.BLACK_COLOR,
                    name: this.translate.instant('BLACK_COLOR')
                },
                {
                    key: this.trackingLineColorValue.BLUE_COLOR,
                    name: this.translate.instant('BLUE_COLOR')
                },
                {
                    key: this.trackingLineColorValue.GREEN_COLOR,
                    name: this.translate.instant('GREEN_COLOR')
                },
                {
                    key: this.trackingLineColorValue.RED_COLOR,
                    name: this.translate.instant('RED_COLOR')
                }
            ];
            this.languageOptions = [
                {
                    key: 'de',
                    name: 'Deutsch'
                },
                {
                    key: 'en',
                    name: 'English'
                }
            ];
        });
    }

    onDismiss() {
        this.viewCtrl.dismiss({ markerChanged: this.markerChanged });
    }

    public get trackingLineWidthValue(): typeof TrackingLineWidth {
        return TrackingLineWidth;
    }

    public get trackingLineColorValue(): typeof TrackingLineColor {
        return TrackingLineColor;
    }

    public get pluginAccuracy(): typeof PluginAccuracy {
        return PluginAccuracy;
    }

    onPluginAccuracyChange() {
        this.trackingService.setPluginAccuracy();
    }

    locationExportChange() {
        if (!this.trackingService.options.locationExport) {
            this.trackingService.removePos();
        }
        this.trackingService.reconfigurePlugin();
        this.trackingService.updateTrackingSettings();
    }

    changeLanguage() {
        this.settingsService.setLanguage(this.selectedLanguage).then(() => {
            this.init(true);
        });
        this.ref.detectChanges();
        this.ref.markForCheck();
    }

    changeDateFormat() {
        console.log(this.selectedDateFormat);
        let format = this.formats.find(f => f.key == this.selectedDateFormat);
        this.settingsService.setDateFormat(format);
        this.ref.detectChanges();
        this.ref.markForCheck();
    }
    get selectedDateFormatName(): string {
        const found = this.formats.find(f => f.key === this.selectedDateFormat);
        return found?.name ?? this.selectedDateFormat;
    }
}
